import ManagementNotes from './ManagementNotes';

export default ManagementNotes;
